import { useState } from "react";
import { Check, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal } from "./Reveal";
import { PRICE, SUMMARY_FEATURES } from "../data/pricing";

export const PricingSummary = () => {
  const [currency, setCurrency] = useState("GBP");
  const p = PRICE[currency];
  const navigate = useNavigate();

  return (
    <section id="pricing-summary" className="px-5 md:px-10 py-10 md:py-16">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="glass-panel px-6 py-12 md:px-14 md:py-16">
            <div className="grid lg:grid-cols-2 gap-10 items-center">
              <div>
                <p className="text-xs font-bold tracking-[0.22em] text-[#39D5FF] mb-4">TRANSPARENT PRICING</p>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#F7FAFF]">
                  Simple, <span className="text-gradient">Honest Pricing.</span>
                </h2>
                <p className="mt-5 text-base md:text-lg text-[#AEBFD8] leading-relaxed max-w-lg">
                  One fixed price. No monthly fees. No hidden costs. Everything you need to get your business online.
                </p>

                <div className="mt-7 inline-flex p-1 rounded-full bg-[#06152D]/80 border border-[rgba(67,157,255,0.35)]" data-testid="summary-pricing-toggle">
                  {["GBP", "USD"].map((c) => (
                    <button key={c} onClick={() => setCurrency(c)} data-testid={`summary-currency-${c}`}
                      className={`px-6 py-2 rounded-full text-sm font-bold transition-all min-h-[40px] ${
                        currency === c ? "btn-primary" : "text-[#AEBFD8] hover:text-[#F7FAFF]"
                      }`}>
                      {PRICE[c].label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="glass-card p-6 md:p-8 relative overflow-hidden">
                <div className="absolute -right-16 -top-16 w-48 h-48 rounded-full bg-[radial-gradient(circle,rgba(0,168,255,0.25),transparent_70%)] blur-2xl pointer-events-none" />
                <h3 className="text-xl font-bold text-[#F7FAFF] relative z-10">Core Website Package</h3>
                <div className="mt-4 flex items-end gap-2 relative z-10">
                  <span className="text-5xl font-extrabold text-[#F7FAFF]">{p.symbol}{p.base}</span>
                  <span className="text-sm text-[#7F92AE] mb-2">{p.region}</span>
                </div>
                <ul className="mt-5 space-y-2.5 relative z-10">
                  {SUMMARY_FEATURES.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm text-[#AEBFD8]">
                      <Check size={16} className="text-[#45E0B5] mt-0.5 shrink-0" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-7 flex flex-col sm:flex-row gap-3 relative z-10">
                  <button onClick={() => navigate("/pricing")} data-testid="summary-see-full-pricing"
                    className="btn-secondary inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold flex-1 min-h-[44px]">
                    See Full Pricing
                  </button>
                  <button onClick={() => navigate("/contact")} data-testid="summary-get-started"
                    className="btn-primary inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-bold flex-1 min-h-[44px]">
                    Get Started <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
